<template>
  <div class="student-container">
    <el-row>
      <el-col :span="isGeneralAdmin || hasFilter ? 12 : 24">
        <organization-breadcrumb
          :items="[
            $t($i18nLabelsHelper($store.getters['organization/currentOrganizationType'], 'students_page.title')),
          ]"
        />
      </el-col>
      <el-col v-if="isGeneralAdmin || hasFilter" :span="12">
        <admin-organization-switcher />
      </el-col>
    </el-row>
    <base-table-loading v-if="loading" :data="skeletonData" />
    <template v-else>
      <div class="team-tab-body" v-if="isEmptyData">
        <div class="no-team">
          <user-icon />
          <h2 class="no-item-title">{{ $t("student.theres_no_learner_in_org") }}</h2>
          <p class="no-item-desc">{{ $t("student.invite_your_team") }}</p>
          <!-- <button v-if="isOrganizationUseDummyEmail" @click="openInviteDummyLearner">
            <i class="el-icon-circle-plus-outline" />
            {{ $t("student.generate_dummy_learners") }}
          </button> -->
          <button @click="openInviteLearner">
            <i class="el-icon-circle-plus-outline" />
            {{ $t("student.invite_learners") }}
          </button>
        </div>
      </div>
      <elsa-table-layout
        v-else
        :pager-counter="pageCounter"
        :pageSize="numberElementsPerPage"
        :total="studentsCount"
        :currentChange="getStudentPage"
        :current-page.sync="currentPage"
        :queryString.sync="queryString"
        :query-placeholder="$t('common.search')"
        :search="searchStudents"
        :pendingInviteUsers="pendingInviteUsersPage"
        :pendingUsersCurrentPage.sync="pendingInviteUsersCurrentPage"
        :totalPendingUsers="pendingUsersCount"
        v-on:invite-learner="modals.showInviteLearnerModal = true"
        v-on:invite-dummy-learner="modals.showInviteDummyLearnerModal = true"
        :isOrganizationUseDummyEmail="isOrganizationUseDummyEmail"
        :inviteButtonLabel="
          $t($i18nLabelsHelper($store.getters['organization/currentOrganizationType'], 'students_page.invite'))
        "
        :title="$t($i18nLabelsHelper($store.getters['organization/currentOrganizationType'], 'students_page.title'))"
        :dummyEmailInviteButtonLabel="
          $t(
            $i18nLabelsHelper(
              $store.getters['organization/currentOrganizationType'],
              'students_page.generate_dummy_learners'
            )
          )
        "
      >
        <template v-slot:drop-down>
          <span class="action-item invite-users" @click="inviteMode = 'email-invite'">
            <i class="elsa-icon-email" />
            {{ $t("organizations.users_section.invite_by_email") }}
          </span>
          <span class="action-item import-users" @click="inviteMode = 'import-users'">
            <i class="elsa-icon-import" />
            {{ $t("organizations.users_section.import_users") }}
          </span>
        </template>
        <div class="table-wrapper">
          <el-table :data="students" style="width: 100%" :empty-text="$t('common.no_values')">
            <user-info-table-column :label="$t('common.name')" sortable prop="composed" width="230" />
            <!-- <el-table-column
              prop="package"
              sortable
              label="Elsa access"
              >
              <template slot-scope="scope">
                <div>{{getNameMembership(scope.row['package'])}}</div>
              </template>
          </el-table-column> -->
            <el-table-column
              v-if="isElsaSpeakProduct"
              prop="group"
              sortable
              :sort-method="sortClass"
              :label="$t($i18nLabelsHelper($store.getters['organization/currentOrganizationType'], 'group'))"
            >
              <template slot-scope="scope">
                <div v-if="scope.row['group']">{{ scope.row["group"]["name"] }}</div>
                <div v-else class="invite-owner" @click="openAddLearner(scope.row)">
                  <i class="el-icon-circle-plus-outline" />
                  {{
                    $t($i18nLabelsHelper($store.getters["organization/currentOrganizationType"], "add_to_group_title"))
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="isElsaSpeakProduct"
              prop="group"
              sortable
              :sort-method="sortTeacher"
              :label="$t($i18nLabelsHelper($store.getters['organization/currentOrganizationType'], 'teacher'))"
            >
              <template slot-scope="scope">
                <div v-if="scope.row['group']" class="owner-info">
                  <p>
                    {{
                      scope.row["group"]["owner"]
                        ? scope.row["group"]["owner"]["first_name"] + " " + scope.row["group"]["owner"]["last_name"]
                        : ""
                    }}
                  </p>
                  <p>{{ scope.row["group"]["owner"] ? scope.row["group"]["owner"]["email"] : "" }}</p>
                </div>
              </template>
            </el-table-column>
            <base-table-column
              prop="created"
              dataType="date"
              sortable
              sort-by="created"
              :label="$t('organization_profile.date_joined')"
            >
            </base-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <div class="flex">
                  <span class="edit-learner" @click="editLearner(scope.row)" :title="$t('student.edit_learner')">
                    <i class="elsa-icon-edit" />
                  </span>
                  <span
                    v-if="isOrganizationAdmin || isOrganizationAssociateAdmin"
                    class="remove-learner"
                    @click="removeLearner(scope.row['id'])"
                    :title="$t('student.remove_learner')"
                  >
                    <i class="elsa-icon-grey-delete" />
                  </span>
                  <button
                    v-if="isOrganizationUseDummyEmail"
                    class="copy-credential"
                    @click="copyCredentials(scope.row['id'])"
                  >
                    <i class="el-icon-document-copy" />
                    {{ $t("common.copy_credential") }}
                  </button>
                  <span
                    v-if="isOrganizationUseDummyEmail"
                    class="change-password"
                    @click="changePasswordCTA(scope.row['id'])"
                    :title="$t('common.change_password')"
                  >
                    <i class="elsa-icon-password-reset" />
                  </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </elsa-table-layout>
      <invite-learners
        :dialogVisible="modals.showInviteLearnerModal && !inviteMultipleMode"
        :inviteMultipleMode.sync="inviteMultipleMode"
        v-on:closed="modals.showInviteLearnerModal = false"
        :organizationId="currentOrganizationId"
        v-on:update-pending="getPendingPage"
        :isOrganizationUseDummyEmail="false"
      />
      <invite-learners
        :dialogVisible="modals.showInviteDummyLearnerModal && !inviteMultipleMode"
        :inviteMultipleMode.sync="inviteMultipleMode"
        v-on:closed="modals.showInviteDummyLearnerModal = false"
        :organizationId="currentOrganizationId"
        v-on:update-pending="getPendingPage"
        :isOrganizationUseDummyEmail="isOrganizationUseDummyEmail"
      />
      <invite-multiple-learners
        :dialogVisible="modals.showInviteLearnerModal && inviteMultipleMode"
        :inviteMultipleMode.sync="inviteMultipleMode"
        v-on:closed="modals.showInviteLearnerModal = false"
        :organizationId="currentOrganizationId"
        v-on:update-pending="getPendingPage"
        :organizationType="currentOrganizationType"
        :shouldShowInviteAll="true"
        :isOrganizationUseDummyEmail="false"
      />
      <invite-multiple-learners
        :dialogVisible="modals.showInviteDummyLearnerModal && inviteMultipleMode"
        :inviteMultipleMode.sync="inviteMultipleMode"
        v-on:closed="modals.showInviteDummyLearnerModal = false"
        :organizationId="currentOrganizationId"
        v-on:update-pending="getPendingPage"
        :organizationType="currentOrganizationType"
        :shouldShowInviteAll="true"
        :isOrganizationUseDummyEmail="isOrganizationUseDummyEmail"
      />
      <add-learners
        :dialogVisible="modals.showAddLearnerToTeamModal"
        v-on:closed="modals.showAddLearnerToTeamModal = false"
        :user="currentUserAddToTeam"
        v-on:update-learner="getStudentPage"
      />
      <edit-organization-learner
        :dialogVisible="modals.showEditLearnerModal"
        v-on:closed="modals.showEditLearnerModal = false"
        :organizationType="currentOrganizationType"
        @updateLearner="updateLearner"
        :userEdited="userEdited"
        :title="$t('organization_profile.admin_actions.edit_user')"
      />
      <view-dummy-email-credential
        :dialogVisible="modals.showViewCredentialModal"
        v-on:closed="modals.showViewCredentialModal = false"
        :dummyEmailCredential="dummyEmailCredential"
      />
      <delete-organization-user
        :dialogVisible="modals.showRemoveAccountModal"
        v-on:closed="modals.showRemoveAccountModal = false"
        @doRemoveStudentFromOrg="handelRemoveFromOrganization"
      />
      <change-pass-dummy-email
        :dialogVisible="modals.showChangePassDummyEmailModal"
        v-on:closed="modals.showChangePassDummyEmailModal = false"
        @change-pass-dummy="doChangePassDummy"
      />
    </template>
  </div>
</template>

<script>
import userIcon from "@/assets/images/inline.user-icon-big.svg";
import ElsaTableLayout from "@/components/common/ElsaTableLayout";
import UserInfoTableColumn from "@/components/classes/UserInfoTableColumn";
import OrganizationBreadcrumb from "@/components/common/OrganizationBreadcrumb";
// import InviteUsers from '@/components/modals/organizations/InviteUsers'
import InviteLearners from "@/components/modals/organizations/InviteLearners";
import InviteMultipleLearners from "@/components/modals/organizations/InviteMultipleLearners";
import AddLearners from "@/components/modals/organizations/AddLearnerToTeam";
import BaseTableColumn from "@/components/classes/BaseTableColumn";
import { mapGetters, mapActions } from "vuex";
import { NUMBER_ELEMENTS_PER_PAGE, PAGE_COUNTER } from "../constants/generic";
// import { STUDENT } from '../constants/userRoles'
import { warningMessage, successMessage } from "../utils/messages";
import DeleteOrganizationUser from "@/components/modals/organizations/DeleteOrganizationUsers";
import { always, pathOr } from "ramda";
import { memberships } from "@/helpers/memberships";
import EditOrganizationLearner from "@/components/modals/organizations/EditOrganizationLearner";
import ViewDummyEmailCredential from "@/components/modals/organizations/ViewDummyEmailCredential";
import AdminOrganizationSwitcher from "@/components/dashboard/AdminOrganizationSwitcher";
import BaseTableLoading from "@/components/common/BaseTableLoading.vue";
import ChangePassDummyEmail from "@/components/modals/organizations/ChangePassDummyEmail.vue";

export default {
  components: {
    BaseTableLoading,
    ElsaTableLayout,
    UserInfoTableColumn,
    OrganizationBreadcrumb,
    userIcon,
    EditOrganizationLearner,
    ViewDummyEmailCredential,
    InviteLearners,
    InviteMultipleLearners,
    BaseTableColumn,
    AddLearners,
    DeleteOrganizationUser,
    AdminOrganizationSwitcher,
    ChangePassDummyEmail,
  },
  computed: {
    ...mapGetters("students", ["paginateStudents", "dummyEmailCredential"]),
    ...mapGetters("organization", [
      "currentOrganizationId",
      "pendingUsersCount",
      "pendingInviteUsersPage",
      "isOrganizationAdmin",
      "isOrganizationAssociateAdmin",
      "isGeneralAdmin",
      "hasFilter",
      "isElsaSpeakProduct",
    ]),
    ...mapGetters({
      currentOrganizationType: "organization/currentOrganizationType",
      isOrganizationUseDummyEmail: "organization/isOrganizationUseDummyEmail",
      currentOrganizationId: "organization/currentOrganizationId",
      currentOrganization: "organization/currentOrganization",
    }),
    pageCounter: always(PAGE_COUNTER),
    numberElementsPerPage: always(NUMBER_ELEMENTS_PER_PAGE),
    studentsCount: pathOr(0, ["paginateStudents", "count"]),
    students: pathOr([], ["paginateStudents", "results"]),
  },
  data() {
    return {
      currentPage: 1,
      pendingInviteUsersCurrentPage: 1,
      queryString: null,
      inviteMultipleMode: false,
      modals: {
        showInviteDummyLearnerModal: false,
        showInviteLearnerModal: false,
        showAddLearnerToTeamModal: false,
        showRemoveAccountModal: false,
        showEditLearnerModal: false,
        showViewCredentialModal: false,
        showChangePassDummyEmailModal: false,
      },
      currentUserAddToTeam: null,
      userIdRemoved: null,
      userEdited: {
        id: "",
        first_name: "",
        last_name: "",
        roles: [],
      },
      userIDToChangePass: null,
      isEmptyData: false,
      loading: true,
      skeletonData: [
        {
          name: "Name",
          label: "Name",
          layout: [
            {
              width: "30%",
              justifyContent: "center",
              alignItems: "center",
              items: [
                {
                  width: "40px",
                  height: "40px",
                  type: "circle",
                },
              ],
            },
            {
              width: "70%",
              items: [
                {
                  type: "rectangle",
                  width: "60%",
                  height: "12px",
                },
                {
                  width: "100%",
                  height: "12px",
                  type: "rectangle",
                },
              ],
            },
          ],
        },
        {
          name: "Class",
          label: "Class",
          layout: [
            {
              width: "100%",
              items: [
                {
                  width: "100%",
                  height: "12px",
                  type: "rectangle",
                },
              ],
            },
          ],
        },
        {
          name: "Teacher",
          label: "Teacher",
          layout: [
            {
              width: "100%",
              items: [
                {
                  width: "100%",
                  height: "12px",
                  type: "rectangle",
                },
              ],
            },
          ],
        },
        {
          name: "Date Joined",
          label: "Date Joined",
          layout: [
            {
              width: "100%",
              items: [
                {
                  width: "100%",
                  height: "12px",
                  type: "rectangle",
                },
              ],
            },
          ],
        },
        {
          name: "Action",
          label: "",
          layout: [
            {
              width: "100%",
              items: [
                {
                  width: "100%",
                  height: "12px",
                  type: "rectangle",
                },
              ],
            },
          ],
        },
      ],
    };
  },
  props: ["new", "organizationId"],
  methods: {
    searchStudents(search) {
      return this.getStudents({ search });
    },
    ...mapActions("students", ["getStudents", "getStudentDummyEmailCredential"]),
    ...mapActions("invite", ["inviteUsers"]),
    ...mapActions({
      removeFromOrganization: "organization/removeFromOrganization",
      // removeUserFromSystem: 'user/removeUserFromSystem',
      updateOrganizationUserInfo: "organization/updateOrganizationUserInfo",
    }),
    sortClass(studentA, studentB) {
      if (studentA.group && studentB.group) {
        return studentA.group.name.localeCompare(studentB.group.name);
      } else if (studentA.group) {
        return 1;
      } else if (studentB.group) {
        return -1;
      } else {
        return 0;
      }
    },
    sortTeacher(studentA, studentB) {
      if (studentA.group && studentA.group.owner && studentB.group && studentB.group.owner) {
        const nameAConstructable = studentA.group.owner.first_name || studentA.group.owner.last_name;
        const nameBConstructable = studentB.group.owner.first_name || studentB.group.owner.last_name;
        // Neu ca 2 deu co first name hoac last name
        if (nameAConstructable && nameBConstructable) {
          const nameA = studentA["group"]["owner"]["first_name"] + " " + studentA["group"]["owner"]["last_name"];
          const nameB = studentB["group"]["owner"]["first_name"] + " " + studentB["group"]["owner"]["last_name"];
          return nameA.localeCompare(nameB);
        } else if (nameAConstructable) {
          return 1;
        } else if (nameBConstructable) {
          return -1;
        } else {
          return studentA.group.owner.email.localeCompare(studentB.group.owner.email);
        }
      } else if (studentA.group && studentA.group.owner) {
        return 1;
      } else if (studentB.group && studentB.group.owner) {
        return -1;
      } else {
        return 0;
      }
    },
    getStudentPage(page) {
      const search = this.queryString;
      return this.getStudents({ page, search });
    },
    getPendingPage() {
      this.getPendingInviteStudents();
    },
    editLearner(learner) {
      this.modals.showEditLearnerModal = true;
      this.userEdited = {
        id: learner.id,
        first_name: learner.first_name,
        last_name: learner.last_name,
        roles: learner.roles,
      };
    },
    copyCredentials(learnerId) {
      this.getStudentDummyEmailCredential({
        organizationId: this.currentOrganizationId,
        studentId: learnerId,
      });
      this.modals.showViewCredentialModal = true;
    },
    removeLearner(learner_id) {
      this.modals.showRemoveAccountModal = true;
      this.userIdRemoved = learner_id;
    },
    updateLearner(user) {
      this.updateOrganizationUserInfo({
        userId: user.id,
        organizationId: this.organizationId,
        first_name: user.first_name,
        last_name: user.last_name,
        roles: user.roles,
      })
        .then(() => {
          const message = this.$i18nLabelsHelper(
            this.$store.getters["organization/currentOrganizationType"],
            "update_learner_of_organization_success"
          );
          successMessage(this.$t(message))(this);
          this.getStudentPage(this.currentPage);
        })
        .catch(error => {
          const message = this.$i18nLabelsHelper(
            this.currentOrganizationType,
            "update_learner_of_organization_warning"
          );
          return warningMessage(this.$t(message))(this);
        });
    },
    handelRemoveFromOrganization(isRemoveUserFromSystem = false) {
      this.removeFromOrganization({
        userId: this.userIdRemoved,
        organizationId: this.organizationId,
        isRemoveUserFromSystem,
      })
        .then(() => {
          const message = this.$i18nLabelsHelper(
            this.$store.getters["organization/currentOrganizationType"],
            "remove_from_organization_success"
          );
          successMessage(this.$t(message))(this);
          this.getStudentPage(this.currentPage);
        })
        .catch(error => {
          const message = this.$i18nLabelsHelper(this.currentOrganizationType, "remove_from_organization_warning");
          return warningMessage(this.$t(message))(this);
        });
    },
    changePasswordCTA(learner_id) {
      this.modals.showChangePassDummyEmailModal = true;
      this.userIDToChangePass = learner_id;
    },
    doChangePassDummy(form) {
      this.$store
        .dispatch("organization/changePassDummyEmail", {
          organizationId: this.currentOrganizationId,
          userId: this.userIDToChangePass,
          ...form,
        })
        .then(() => {
          const message = this.$i18nLabelsHelper(
            this.$store.getters["organization/currentOrganizationType"],
            "change_pass_dummy_email_success"
          );
          successMessage(this.$t(message))(this);
        })
        .catch(error => {
          const message = this.$i18nLabelsHelper(this.currentOrganizationType, "change_pass_dummy_email_warning");
          return warningMessage(this.$t(message))(this);
        });
    },
    ...mapActions("organization", ["getPendingInviteStudents"]),
    openInviteLearner() {
      this.modals.showInviteLearnerModal = true;
      try {
        this.$gtag.event(`add-learner-submit`, {
          category: `Time-Spent`,
          label: `Add Learners`,
        });
      } catch (error) {
        const message = "error";
      }
    },
    openInviteDummyLearner() {
      this.modals.showInviteDummyLearnerModal = true;
      try {
        this.$gtag.event(`add-learner-submit`, {
          category: `Time-Spent`,
          label: `Add Learners`,
        });
      } catch (error) {
        const message = "error";
      }
    },
    openAddLearner(user) {
      this.modals.showAddLearnerToTeamModal = true;
      this.currentUserAddToTeam = user;
    },
    getNameMembership(membership_id) {
      if (membership_id in memberships) {
        return memberships[membership_id]["full_name"];
      }
      return "";
    },
    async checkValidPassResetRequest(requestId) {
      try {
        const response = await this.$axios.get(`/v1/schools/password-reset-requests/${requestId}/check-valid`);
        if (!response.data.valid) {
          warningMessage(response.data.message)(this);
        }
      } catch (error) {
        return false;
      }
    },
  },
  async mounted() {
    try {
      this.loading = true;
      await this.getStudents();
      if (this.studentsCount == 0) {
        this.isEmptyData = true;
      }
      if (this.isOrganizationAdmin) {
        await this.getPendingInviteStudents();
      }
      if (this.$route.query.request) {
        const requestId = this.$route.query.request;
        this.checkValidPassResetRequest(requestId);
      }
    } finally {
      this.loading = false;
    }
  },
  watch: {
    pendingInviteUsersCurrentPage(page) {
      if (this.isOrganizationAdmin) {
        return this.getPendingInviteStudents({ page });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/_colors.scss";
.student-container {
  width: 100%;
  .owner-info {
    span {
      font-weight: 500;
      font-size: 18px;
      color: $black;
    }
    p {
      font-weight: 500;
      font-size: 18px;
      text-transform: capitalize;
      color: $black;
      margin: 0;
      text-align: initial;
      display: flex;
      align-items: center;
      &:last-of-type {
        font-size: 14px;
        color: $light-blue-2;
        text-transform: none;
        line-height: 34px;
      }
      span {
        font-weight: normal;
        font-size: 11px;
        color: rgba(109, 122, 140, 0.5);
        padding-left: 3px;
        display: flex;
        align-items: center;
        i {
          font-size: 18px;
          vertical-align: text-bottom;
          margin-right: 5px;
        }
      }
    }
  }
}
.team-tab-body {
  padding: 40px;
  text-align: center;
}

button {
  background: #007eff;
  border-radius: 8px;
  border: none;
  height: 48px;
  color: white;
  padding: 16px;
  font-size: 18px;
  cursor: pointer;
  white-space: nowrap;
  margin: 0 10px;
  &:hover {
    background: #0362c4;
  }
}
button.copy-credential {
  background: #007eff;
  border-radius: 8px;
  border: none;
  height: 32px;
  color: white;
  padding: 8px 14px;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  margin: 0 10px;
  &:hover {
    background: #0362c4;
  }
}
.no-item-title {
  font-weight: 600;
  font-size: 32px;
  text-align: center;
}
.no-item-desc {
  font-size: 18px;
}
.invite-owner {
  font-weight: 700;
  font-size: 14px;
  color: $purple;
  text-align: initial;
  cursor: pointer;
  padding-top: 24px;
  i {
    font-size: 20px;
    vertical-align: bottom;
    margin-right: 5px;
  }
}
</style>
